import { Box, FormField, RangeInput, Text, TextInput } from "grommet"
import RangeInputWithEdit from "../../../../forms/RangeInputWithEdit";
import { useTranslation } from "react-i18next";

const ShadowSettingsForm = ({ shadowColorInputName, shadowHorizontalOffsetInputName, shadowVerticalOffsetInputName, shadowBlurInputName }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
            <FormField label={t('shadowColorLabel')}>
                <TextInput name={shadowColorInputName} type="color" />
            </FormField>
            <FormField label={t('horizontalOffsetLabel')} noBorder noFocus>
                <RangeInputWithEdit name={shadowHorizontalOffsetInputName} type="number" unit={'px'} min={-15} max={15} step={1} />
            </FormField>
            <FormField label={t('verticalOffsetLabel')} noBorder noFocus>
                <RangeInputWithEdit name={shadowVerticalOffsetInputName} type="number" unit={'px'} min={-15} max={15} step={1} />
            </FormField>
            <FormField label={t('shadowBlurLabel')} noBorder noFocus>
                <RangeInputWithEdit name={shadowBlurInputName} type="number" unit={'px'} min={-15} max={15} step={1} />
            </FormField>
        </Box>
    )
}

export default ShadowSettingsForm;